class MedicationNote {
    public Id: string;

    // These fields are only added when note is loaded
    public MedicationId: string;
    public PatientId: string;
    public EmployeeId: string;
    public CreationDate: Date;
    public Note: string = "";

    // Only set in the front end
    public IsLoaded: boolean = false;

    public constructor(init?: Partial<MedicationNote>) {
        Object.assign(this, init);
    }
}

export { MedicationNote };
